module.exports = __webpack_public_path__ + "static/media/pid_profiler_work.1cd30cda.svg";